<template>
    <v-container fluid class="page-container">
        <page-header title="Dealers" :subtitle="totalLabel">
            <v-btn color="primary" depressed @click="createItem">
                <v-icon left>mdi-plus</v-icon>New dealer
            </v-btn>
        </page-header>

        <filter-panel :fields="filterFields" :value="listState" :loading="loading" @apply="applyFilters" />

        <v-card outlined>
            <v-data-table
                :headers="visibleHeaders"
                v-bind="tableBindings"
                class="list-table clickable-rows"
                no-data-text="No dealers match this search"
                @update:options="onTableOptions"
                @click:row="openItem($event)"
            >
                <template v-slot:[`item.name`]="{ item }">
                    <span class="font-weight-medium">{{ item.firstName }} {{ item.lastName }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <v-btn icon small color="primary" title="Edit" @click.stop="openItem(item, 'edit')">
                            <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <delete-button
                            title="Delete this dealer?"
                            text="Their login account is deleted as well."
                            @delete-entry="deleteItem(item, deleteDealer, 'Dealer')"
                        />
                    </div>
                </template>
            </v-data-table>
            <table-footer v-model="page" :page-count="pageCount" :total="total" :items-per-page="itemsPerPage" />
        </v-card>
    </v-container>
</template>

<script>
    import dealerService from '@/services/dealer-service'
    import paginatedList from '@/mixins/paginated-list'
    import PageHeader from '@/components/PageHeader'
    import FilterPanel from '@/components/FilterPanel'
    import TableFooter from '@/components/TableFooter'
    import DeleteButton from '@/components/DeleteButton'

    export default {
        name: 'DealerRoute',
        components: { PageHeader, FilterPanel, TableFooter, DeleteButton },
        mixins: [paginatedList],
        data() {
            return {
                filterFields: [
                    { key: 'search', label: 'Search', placeholder: 'Name or email' }
                ],
                headers: [
                    { text: 'Id', value: 'id', width: 80 },
                    { text: 'Name', value: 'name' },
                    { text: 'Email', value: 'email' },
                    { text: '', value: 'actions', align: 'end', sortable: false, width: 96 }
                ]
            }
        },
        methods: {
            fetchPage: options => dealerService.getDealersPage(options),
            deleteDealer: id => dealerService.deleteDealerById(id)
        }
    }
</script>
